import { render, staticRenderFns } from "./BasePassword.vue?vue&type=template&id=a7f327ac&scoped=true"
import script from "./BasePassword.vue?vue&type=script&lang=js"
export * from "./BasePassword.vue?vue&type=script&lang=js"
import style0 from "./BasePassword.vue?vue&type=style&index=0&id=a7f327ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f327ac",
  null
  
)

export default component.exports